// extracted by mini-css-extract-plugin
module.exports = {"root":"AcceptanceNameAndPeriod_root__2pO00","name":"AcceptanceNameAndPeriod_name__1cx9t"};